import React from 'react';
import { Wrapper, Label, ImgWrapper, Img } from './styled';

const ThankYouComponent = () => {
    return (
        <Wrapper>
            <Label></Label>
        </Wrapper>
    );
};

const EndContainer = () => {
    return <ThankYouComponent />;
};

export default EndContainer;
